export class EnvService{
    static getBackEndUrl():string|undefined{
        return process.env.REACT_APP_BACKEND_URL
    }
    static getLogLevel(){
        return process.env.REACT_APP_LOG_LEVEL;
    }
    static authModeIsMock(){
        return process.env.REACT_APP_AUTH === "MOCK";
    }
    static isTestEnvironment(): boolean {
        return (
            process.env.REACT_APP_TEST_ENVIRONMENT === 'true' ||
            process.env.NODE_ENV === 'development'
        );
    }
    static isProduction(): boolean {
        return process.env.NODE_ENV === 'production' && process.env.REACT_APP_TEST_ENVIRONMENT !== 'true';
    }
}